import { SCol, SRow, SAlert } from '@avalara/skylab-sdk/react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { embeddedViewRequested } from '../../../../lib/helpers';
import { selectIsNonAdmin, selectState } from '../../../../selectors';
import { purchaseDeflectionWording } from '../../../helpers';
import OfferBox from '../../box';
import NextButton from '../shared/next-button';
import ExemptionsOfferPlan from './exemptions-offer-plan';
const ExemptionsPlanSelect = ({ plans }) => {
    const [selectedPlanName, selectPlanName] = useState('');
    const isNonAdmin = useSelector(selectIsNonAdmin);
    const { account: { isLoggedIn, }, } = useSelector(selectState);
    useEffect(() => {
        if (plans.length)
            selectPlanName(plans[0].name);
    }, [plans]);
    return (React.createElement(React.Fragment, null,
        (isLoggedIn && isNonAdmin) &&
            React.createElement(SAlert, { status: 'info', noDismiss: true, className: 'margin-all-sm' },
                React.createElement("div", null, purchaseDeflectionWording)),
        React.createElement(OfferBox, { isEmbedded: embeddedViewRequested(), className: 'margin-all-sm pad-all-sm' },
            React.createElement(SRow, null,
                React.createElement(SCol, null,
                    React.createElement("p", { className: 'margin-top-sm text-md' }, "Choose a plan that works for your business"))),
            React.createElement(SRow, null, plans === null || plans === void 0 ? void 0 : plans.map(plan => (React.createElement(SCol, { key: plan.name, span: 'auto', className: 'flex justify-content-center' },
                React.createElement(ExemptionsOfferPlan, { plan: plan, selected: selectedPlanName === plan.name, onSelect: () => selectPlanName(plan.name), isDisabled: (isLoggedIn && isNonAdmin) }))))),
            React.createElement(SRow, null,
                React.createElement(SCol, { span: 'auto', className: 'flex align-items-center justify-content-space' },
                    React.createElement("p", { className: 'margin-right-lg', "data-ref": 'exemptions.plan-select.need-help' }, "Need help deciding on a plan?"),
                    React.createElement(NextButton, { selectedPlanName: selectedPlanName, disableButton: (isLoggedIn && isNonAdmin) }))))));
};
export default ExemptionsPlanSelect;
